// test1507
(1507 && 0);
